import { useState, MouseEvent } from 'react';
import { Button, Menu, MenuItem, ListItemText } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link } from 'react-router-dom';

export interface ActionMenuItem {
  key: string;
  label: string;
  disabled?: boolean;
  to?: string;
  onClick?: () => void;
}

interface ActionsMenuProps {
  items: ActionMenuItem[];
  buttonLabel?: string;
}

function ActionsButtonMenu({
  items,
  buttonLabel = 'Actions',
}: ActionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        variant="contained"
        size="large"
        color="primary"
        onClick={(event: MouseEvent<HTMLElement>) =>
          setAnchorEl(event.currentTarget)
        }
        aria-haspopup="true"
        endIcon={<KeyboardArrowDownIcon />}>
        {buttonLabel}
      </Button>
      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '0.5rem !important',
              mt: '1.5rem !important',
              ml: '6.5rem !important',
            },
          },
        }}>
        {items.map((item) =>
          item.to ? (
            <MenuItem
              key={item.key}
              component={Link}
              to={item.to}
              disabled={item.disabled}
              onClick={handleClose}>
              <ListItemText>{item.label}</ListItemText>
            </MenuItem>
          ) : (
            <MenuItem
              key={item.key}
              disabled={item.disabled}
              onClick={() => {
                item.onClick?.();
                handleClose();
              }}>
              <ListItemText>{item.label}</ListItemText>
            </MenuItem>
          )
        )}
      </Menu>
    </>
  );
}

export default ActionsButtonMenu;
